import { Button } from "baseui/button"
import { FaLightbulb, FaRegLightbulb } from "react-icons/fa"
import { ILight } from "./types"
import { useSetObjectValue } from "../../../hooks/useSetObjectValue";
import { FormattedMessage, useIntl } from "react-intl";
import { themedUseStyletron } from "../../../theme/customTheme";
import { LabelLarge } from "baseui/typography";
import { Banner } from "baseui/banner";
import { OperationState } from "../OperationState";
import { SmallPanel } from "./SmallPanel";

export const ButtonPanel = (props: ILight) => {
    const [, theme] = themedUseStyletron();
    const intl = useIntl();

    const [state, setState, setStateResult] = useSetObjectValue(props.id, props.resourceGroupId, "state", props.state, 10);

    const handleButtonClick = (e: any) => {
        e.stopPropagation();
        e.preventDefault();
        if (props.isOn)
            setState(OperationState.Off);
        else
            setState(OperationState.On);
    }
    const resetManMode = (e: any) => { e.stopPropagation(); e.preventDefault(); setState(OperationState.Auto); };

    const onColor = theme.colors.warning;

    if (!props.isWriteable)
        return (
            <>
                <SmallPanel {...props}></SmallPanel>
                {props.isOn && <LabelLarge><FormattedMessage id="Devices.ON" defaultMessage="ON" /></LabelLarge>}
                {!props.isOn && <LabelLarge color={theme.appColors.aggregate.off}><FormattedMessage id="Devices.OFF" defaultMessage="OFF" /></LabelLarge>}
            </>
        )

    return (<>
        <Button isLoading={setStateResult.isLoading} overrides={{
            BaseButton: {
                style: ({ $theme }) => ({
                    height: theme.sizing.scale1400,
                    width: theme.sizing.scale1400,
                })
            }
        }} kind='secondary' onClick={handleButtonClick}>
            {props.isOn ? <FaLightbulb color={onColor} size='100%' />
                : <FaRegLightbulb color={theme.appColors.aggregate.off} size='40px' />}
        </Button>
        {props.isOn && <LabelLarge><FormattedMessage id="Devices.ON" defaultMessage="ON" /></LabelLarge>}
        {!props.isOn && <LabelLarge color={theme.appColors.aggregate.off}><FormattedMessage id="Devices.OFF" defaultMessage="OFF" /></LabelLarge>}
        {state !== OperationState.Auto && (
            <Banner
                action={{
                    label: intl.formatMessage({ id: "Light.ManReset", defaultMessage: "Reset" }),
                    onClick: resetManMode,
                }}
                overrides={{
                    Root: {
                        style: ({ $theme }) => ({
                            width: '100%'
                        })
                    }
                }}
            ><FormattedMessage id='Light.IsManOverriden' defaultMessage="The light is overwritten manually" />
            </Banner>
        )}
    </>
    )
}